import { render, staticRenderFns } from "./VeJwCjlxList.vue?vue&type=template&id=37986cae&scoped=true"
import script from "./VeJwCjlxList.vue?vue&type=script&lang=js"
export * from "./VeJwCjlxList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37986cae",
  null
  
)

export default component.exports